import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import PolishedToaster from './components/PolishedToaster';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PolishedToaster />
    <App />
  </StrictMode>,
);
